import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function NotFound() {
  return (
    <Box
      sx={{
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{}}>
        <Typography variant="h1" component="div" gutterBottom sx={{ mb: 2 }}>
          404
        </Typography>
        <Typography variant="h6" component="div" gutterBottom sx={{ mb: 2 }}>
          Look like you're lost
        </Typography>
        <Typography
          variant="subtitle1"
          component="div"
          gutterBottom
          sx={{ mb: 2 }}
        >
          The page you are looking for not avaible!
        </Typography>
        <Button variant="outlined" href="/">
          Back To Home
        </Button>
      </Box>
    </Box>
  );
}
